import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $StepHeaderDidactic = styled.div`
  display: block;
  color: ${({ theme }) => theme.colors.paragraphTextColor};
  margin-bottom: ${spacing('lg')};
  white-space: normal;
`;
